export const QUERY_DINAMICA_ALLOWED_EMAILS = [
  'dmorsch@electricservice.com.br',
  'eliane@electricservice.com.br',
  'jeremias@electricservice.com.br',
  'ti@egrid.app',
  'kath@egrid.app',
  'gian@electricservice.com.br',
  'henrique@electricservice.com.br',
  'conrado@electricservice.com.br',
]
